import { Box, Button, Collapse, IconButton, Skeleton, Typography } from '@mui/material';
import palette from '../../../../shared/lib/theme/palette';
import { useAppContext } from '../../app/contexts/AppContext';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import EditIcon from '@mui/icons-material/Edit';
import { useState } from 'react';
import SocialSourceSelector from '../SocialSourceSelector';
import { SocialSource as SocialSourceType, User, useUpdateUserSocialSourceMutation } from '../../generated';
import { Alert } from '../../../../shared/lib/common/Alert';
import { ALERT_REFERRAL_SOURCE_UPDATED, BUTTON_TEXT_UPDATE, LABEL_HOW_DID_YOU_HEAR, LABEL_NOT_AVAILABLE } from '../../../../shared/lib/constants';
import { MSG_PLEASE_SELECT_REFERRAL_SOURCE } from '../../app/constants';

export const SocialSource = () => {
  const { currentUser, setCurrentUser } = useAppContext();
  const { blackTwo, blackOne, blackFive } = palette || {};
  const { userSocialSource } = currentUser || {};
  const { socialSource } = userSocialSource || {};
  const { name } = socialSource || {};
  const [socialLink, setSocialLink] = useState<SocialSourceType | null>(null);

  const [isEdit, setIsEdit] = useState<boolean>(false);

  const [update, { loading }] = useUpdateUserSocialSourceMutation({
    onCompleted: (data) => {
      const { updateUserSocialSource } = data;
      if (updateUserSocialSource && currentUser) {
        const updatedUser: User = { ...currentUser, userSocialSource: updateUserSocialSource };
        setCurrentUser(updatedUser);
        Alert.success(ALERT_REFERRAL_SOURCE_UPDATED);
      }
    },
    onError: ({ message }) => {
      Alert.error(message);
    }
  });

  const onUpdate = async () => {
    if (socialLink?.id) {
      setIsEdit(false);
      await update({
        variables: {
          input: {
            socialSourceId: socialLink.id
          }
        }
      });
    } else {
      Alert.error(MSG_PLEASE_SELECT_REFERRAL_SOURCE);
    }
  };

  return (
    <Box borderBottom={`1px dashed ${blackFive}`} py="16px">
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
        <Typography variant="h2" sx={{ textTransform: 'uppercase', color: blackTwo }}>
          {LABEL_HOW_DID_YOU_HEAR}
        </Typography>

        <IconButton
          color="primary"
          size="large"
          onClick={() => {
            setSocialLink(null);
            setIsEdit(!isEdit);
          }}
        >
          {isEdit ? <ArrowBackIcon /> : <EditIcon />}
        </IconButton>
      </Box>

      <Collapse in={!isEdit}>
        <Typography variant="body2" sx={{ color: { blackOne }, fontWeight: '600' }}>
          {loading ? <Skeleton width={20} /> : name || LABEL_NOT_AVAILABLE}
        </Typography>
      </Collapse>

      <Collapse in={isEdit}>
        <SocialSourceSelector
          value={socialSource || null}
          onChange={(val) => {
            setSocialLink(val);
          }}
        />
        <Box mt={2} display="flex" justifyContent="flex-end" gap={2}>
          <Button variant="contained" size="small" disabled={!socialLink} onClick={onUpdate}>
            {BUTTON_TEXT_UPDATE}
          </Button>
        </Box>
      </Collapse>
    </Box>
  );
};
